<script>
import NastavitvePregledi from "./nastavitve_pregledi.vue";
import NastavitveCamo from "./nastavitve_camo.vue";
import NastavitveUpravitelj from "./nastavitve_upravitelj.vue";
import Notification from "@/components/reUse/Notification.vue";
import NastavitveCurrent from "./nastavitve_current.vue";
export default {
  name: "nastavitve",
  components: {
    NastavitvePregledi,
    NastavitveCamo,
    NastavitveUpravitelj,
    Notification,
    NastavitveCurrent
  },
  data() {
    return {
      AdminPanel: true,
      Pregledi: false,
      Camo: false,
      Upravitelj: false,
      Current: false
    }
  },
  methods: {
    ChosenMenu(chosen) {
      this.AdminPanel = (chosen === 'AdminPanel');
      this.Pregledi = (chosen === 'MeniPregledi')
      this.Camo = (chosen === 'MeniCamo')
      this.Upravitelj = (chosen === 'MeniUpravitelj')
      this.Current = (chosen === 'MeniCurrent')
    },
  }
}
</script>

<template>
  <nav class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas" :class="{'fa-angle-double-left': !AdminPanel, 'fa-arrow-left': AdminPanel}"></i>
            <span>Na glavni meni</span>
          </button>
          &nbsp;
          <button v-if="!AdminPanel" class="back-btn" @click.prevent="ChosenMenu('AdminPanel')">
            <i class="fas fa-arrow-left"></i>
            <span>Na nastavitve</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Upraviteljske nastavitve</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </nav>
  <main v-if="AdminPanel" class="main-content">
    <div class="menu-section">
      <div class="menu-grid">
        <!-- Upravitelj -->
        <div class="menu-card" @click="ChosenMenu('MeniUpravitelj')">
          <div class="menu-icon">
            <i class="fas fa-user-edit"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Nastavljanje upravitelja</h3>
            <p class="menu-description">Podatki upravitelja</p>
          </div>
        </div>
        <!-- Camo nastavitve -->
        <div class="menu-card" @click="ChosenMenu('MeniCamo')">
          <div class="menu-icon">
            <i class="fas fa-users-cog"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Nastavljanje camo uporabnika</h3>
            <p class="menu-description">Upravljanje camo uprabnika/ov</p>
          </div>
        </div>
        <!-- Nastavitve pregledov -->
        <div class="menu-card" @click="ChosenMenu('MeniPregledi')">
          <div class="menu-icon">
            <i class="fas fa-book-reader"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Nastavljanje pregledov</h3>
            <p class="menu-description">Razne nastavitve povezane s pregledi</p>
          </div>
        </div>
        <!-- Nastavitve current -->
        <div class="menu-card" @click="ChosenMenu('MeniCurrent')">
          <div class="menu-icon">
            <i class="fas fa-user"></i>
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Nastavljanje 'current' pilota</h3>
            <p class="menu-description">Nastavljanje pogojev za 'current' pilota</p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <nastavitve-pregledi v-if="Pregledi" />
  <nastavitve-camo v-if="Camo" />
  <nastavitve-upravitelj v-if="Upravitelj" />
  <nastavitve-current v-if="Current" />
</template>
